import { useEffect, useState } from 'react';

/*
 * Tailwind resolve quase toda a responsividade por classe (`md:`, `lg:`), mas
 * alguns componentes precisam do valor em JavaScript — gráficos, por exemplo,
 * recebem raio e margens como números, não como classe CSS.
 *
 * `768px` é o mesmo ponto de corte do `md:` do Tailwind, de propósito: dois
 * pontos de corte diferentes no mesmo sistema criam telas que mudam pela
 * metade.
 */
const CORTE_MD = 768;

export default function useTelaEstreita(largura = CORTE_MD) {
  const consulta = `(max-width: ${largura - 1}px)`;
  const [estreita, setEstreita] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(consulta).matches,
  );

  useEffect(() => {
    const mq = window.matchMedia(consulta);
    const aoMudar = (e) => setEstreita(e.matches);
    setEstreita(mq.matches);
    // Safari antigo só tem addListener; sem isto, girar o aparelho não atualiza.
    if (mq.addEventListener) mq.addEventListener('change', aoMudar);
    else mq.addListener(aoMudar);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', aoMudar);
      else mq.removeListener(aoMudar);
    };
  }, [consulta]);

  return estreita;
}
